import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22856 20755"
    {...props}
  >
    <path
      d="M10143 10498c0-666 547-1205 1221-1205s1221 539 1221 1205-547 1205-1221 1205-1221-539-1221-1205zM7707 20576c1569-561 3147-7007 3147-7007 180 31 283 3 472 3 202 0 396-23 586-58 631 2772 1768 6523 3375 7068 926 314 3209-1030 3356-1986 259-1669-2633-4399-4858-6225 224-284 399-459 514-807h4c2740 866 6591 1797 7880 703 744-629 725-3254-34-3864-1327-1065-5174 16-7895 986h1c-115-299-274-545-470-793 2225-1827 5117-4557 4858-6227-147-955-2430-2299-3356-1985-1607 545-2744 4296-3375 7069-190-36-384-58-585-58-128 0-255 10-379 25-471-2814-1389-6611-2967-7232-909-357-3239 907-3433 1854-336 1636 2330 4478 4426 6420-235 268-426 576-558 914-2680-920-6428-1919-7713-867-768 629-768 3318 0 3948 1285 1053 5033 53 7713-867 123 316 297 605 511 861l-6-4c-2160 1817-4930 4503-4662 6131 161 973 2509 2334 3448 1998z"
      style={{
        fill: "#000",
        // stroke: "#fefefe",
        strokeWidth: 253.288,
      }}
      className="fill"
    />
  </svg>
);
export default SvgComponent;
